import { render, staticRenderFns } from "./CreditInfo.vue?vue&type=template&id=87d124a0"
import script from "./CreditInfo.vue?vue&type=script&lang=js"
export * from "./CreditInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports